import v from "@/module/Utils/variable";

class f {
  static vw(arg: number, device: number = v.pcWidth): string {
    return `${(arg / device) * 100}vw`;
  }

  static pc(): string {
    return `@media (min-width: ${v.breakPoint + 1}px)`;
  }

  static sp(): string {
    return `@media (max-width: ${v.breakPoint}px)`;
  }

  static landscape(): string {
    return `@media screen and (orientation: landscape)`;
  }

  static mediumFont(): object {
    return { fontFamily: "TazuganeGothicStdN-Medium, Ginza" };
  }

  static regularFont(): object {
    return { fontFamily: "TazuganeGothicStdN-Regular, Ginza" };
  }

  static lightFont(): object {
    return { fontFamily: "TazuganeGothicStdN-Light, Ginza" };
  }

  static setZIndex(): object {
    return { position: "relative", zIndex: 2 };
  }
}

export default f;
